import image1 from "../../images/gallery/gallery-image-1.webp"
import image2 from "../../images/gallery/gallery-image-2.webp"
import image3 from "../../images/gallery/gallery-image-3.webp"
import image4 from "../../images/gallery/gallery-image-4.webp"
import image5 from "../../images/gallery/gallery-image-5.webp"
import image6 from "../../images/gallery/gallery-image-6.webp"
import image7 from "../../images/gallery/gallery-image-7.webp"
import image8 from "../../images/gallery/gallery-image-8.webp"
import image9 from "../../images/gallery/gallery-image-9.webp"
import image10 from "../../images/gallery/gallery-image-10.webp"
import image11 from "../../images/gallery/gallery-image-11.webp"
import image12 from "../../images/gallery/gallery-image-12.webp"
import image13 from "../../images/gallery/gallery-image-13.webp"
import image14 from "../../images/gallery/gallery-image-14.webp"
import image15 from "../../images/gallery/gallery-image-15.webp"
import image16 from "../../images/gallery/gallery-image-16.webp"
import image17 from "../../images/gallery/gallery-image-17.webp"
import image18 from "../../images/gallery/gallery-image-18.webp"
import image19 from "../../images/gallery/gallery-image-19.webp"
import image20 from "../../images/gallery/gallery-image-20.webp"
import image21 from "../../images/gallery/gallery-image-21.webp"
import image22 from "../../images/gallery/gallery-image-22.webp"
import image23 from "../../images/gallery/gallery-image-23.webp"
import image24 from "../../images/gallery/gallery-image-24.webp"
import image25 from "../../images/gallery/gallery-image-25.webp"
import image26 from "../../images/gallery/gallery-image-26.webp"
import image27 from "../../images/gallery/gallery-image-27.webp"
import image28 from "../../images/gallery/gallery-image-28.webp"
import image29 from "../../images/gallery/gallery-image-29.webp"
import image30 from "../../images/gallery/gallery-image-30.webp"
import image31 from "../../images/gallery/gallery-image-31.webp"
import image32 from "../../images/gallery/gallery-image-32.webp"
import image33 from "../../images/gallery/gallery-image-33.webp"
import image34 from "../../images/gallery/gallery-image-34.webp"
import image35 from "../../images/gallery/gallery-image-35.webp"
import image36 from "../../images/gallery/gallery-image-36.webp"

function GalleryMain() {
  return (
    <div className="gallery">
      <div>
        <img src={image1} alt="gallery" />
      </div>
      <div>
        <img src={image2} alt="gallery" />
      </div>
      <div>
        <img src={image3} alt="gallery" />
      </div>
      <div>
        <img src={image4} alt="gallery" />
      </div>
      <div>
        <img src={image5} alt="gallery" />
      </div>
      <div>
        <img src={image6} alt="gallery" />
      </div>
      <div>
        <img src={image7} alt="gallery" />
      </div>
      <div>
        <img src={image8} alt="gallery" />
      </div>
      <div>
        <img src={image9} alt="gallery" />
      </div>
      <div>
        <img src={image10} alt="gallery" />
      </div>
      <div>
        <img src={image11} alt="gallery" />
      </div>
      <div>
        <img src={image12} alt="gallery" />
      </div>
      <div>
        <img src={image13} alt="gallery" />
      </div>
      <div>
        <img src={image14} alt="gallery" />
      </div>
      <div>
        <img src={image15} alt="gallery" />
      </div>
      <div>
        <img src={image16} alt="gallery" />
      </div>
      <div>
        <img src={image17} alt="gallery" />
      </div>
      <div>
        <img src={image18} alt="gallery" />
      </div>
      <div>
        <img src={image19} alt="gallery" />
      </div>
      <div>
        <img src={image20} alt="gallery" />
      </div>
      <div>
        <img src={image21} alt="gallery" />
      </div>
      <div>
        <img src={image22} alt="gallery" />
      </div>
      <div>
        <img src={image23} alt="gallery" />
      </div>
      <div>
        <img src={image24} alt="gallery" />
      </div>
      <div>
        <img src={image25} alt="gallery" />
      </div>
      <div>
        <img src={image26} alt="gallery" />
      </div>
      <div>
        <img src={image27} alt="gallery" />
      </div>
      <div>
        <img src={image28} alt="gallery" />
      </div>
      <div>
        <img src={image29} alt="gallery" />
      </div>
      <div>
        <img src={image30} alt="gallery" />
      </div>
      <div>
        <img src={image31} alt="gallery" />
      </div>
      <div>
        <img src={image32} alt="gallery" />
      </div>
      <div>
        <img src={image33} alt="gallery" />
      </div>
      <div>
        <img src={image34} alt="gallery" />
      </div>
      <div>
        <img src={image35} alt="gallery" />
      </div>
      <div>
        <img src={image36} alt="gallery" />
      </div>
    </div>
  );
}

export default GalleryMain